/* React */
import React from 'react';
import { Layout, Row, Col, Button, Input, Space } from 'antd';

/* Biz */
import * as common from 'libs/common';


const Com9998p = (props:any) => {
    const [returnText, setReturnText] = React.useState();
    const { TextArea } = Input;
    const { Content }  = Layout;

    React.useEffect(() => {
        const text = common.isEmptyString(props.defaultText) ? '' : props.defaultText;
        setReturnText(text);
    }, []);

    const onOk = () => {
        if (!props.isNotReq) {
            if(common.isEmptyString(returnText)){
                const param = {
                    title : '위드정보 확인',
                    contents: '필수입력 항목이 누락되었습니다.',
                };

                common.openInfo(param);
                return;
            }
        }

        props.accept(returnText);
    }

	return (
        <Layout>
            <Content>
                <Space direction='vertical'>
                    <Row>
                        <Col flex='100%' className='col-form-input'>
                            <TextArea id='txtContent' style={{ width: props.width && typeof props.width === 'number' ? props.width - 50 : 600 }} value={returnText} autoSize={{ minRows: 4 }} onChange={(e:any) => {
                                setReturnText(e.currentTarget.value);
                            }}/>
                        </Col>
                    </Row>
                    <Row justify='center'>
                        <Col>
                            <Space style={{ marginRight: '3px' }}>
                                {/* 확인 버튼 */}
                                <Button
                                    id='btnSave'
                                    type='default'
                                    className='background-color-primary-button' 
                                    onClick={onOk}
                                >
                                    확인
                                </Button>
                                <Button
                                    id='btnCompt'
                                    type='default'
                                    className='background-color-default-button' 
                                    onClick={() => props.cancel()}
                                >
                                    취소
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Content>
        </Layout>
    );
}

export default Com9998p;